var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBorderCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 31",
    width: 33,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notconnect-interpreter-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #f54a4a } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m23 19.1q0.2 0.1 0.3 0.4q0.1 0.2 0.1 0.4q0 0.2-0.1 0.4q-0.1 0.3-0.3 0.4c-0.2 0.2-0.5 0.4-0.8 0.4c-0.4 0-0.7-0.2-0.9-0.4l-4-3.8l-3.9 3.8q-0.2 0.2-0.4 0.3q-0.2 0.1-0.5 0.1q-0.2 0-0.4-0.1q-0.2-0.1-0.4-0.3q0 0-0.1 0q-0.1-0.2-0.2-0.4q-0.1-0.2-0.1-0.4q0-0.3 0.1-0.5q0.1-0.2 0.3-0.3l4-3.9l-4-3.8c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3 0.1-0.6 0.3-0.8c0.2-0.2 0.5-0.3 0.8-0.3c0.4 0 0.7 0.1 0.9 0.3l3.9 3.9l4-3.9c0.2-0.2 0.5-0.3 0.9-0.3c0.3 0 0.6 0.1 0.8 0.3c0.2 0.2 0.3 0.5 0.3 0.8c0 0.3-0.1 0.6-0.3 0.9l-3.9 3.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m17.4 0c4.1 0 8.1 1.6 11 4.5c3 2.8 4.6 6.7 4.6 10.7c0 4-1.6 7.9-4.6 10.8c-2.9 2.8-6.9 4.4-11 4.4c-4.2 0-8.2-1.6-11.1-4.4c-2.9-2.9-4.6-6.8-4.6-10.8c0-4 1.7-7.9 4.6-10.7c2.9-2.9 6.9-4.5 11-4.5zm-5.1 3c-1.7 0.7-3.2 1.7-4.4 2.9c-2.2 2.2-3.6 5-3.9 8c-0.3 3 0.4 6.1 2.2 8.6c1.7 2.5 4.3 4.4 7.3 5.3c3 0.9 6.2 0.7 9.1-0.4c2.9-1.2 5.3-3.3 6.8-6c1.5-2.7 1.9-5.8 1.3-8.8c-0.6-2.9-2.2-5.6-4.7-7.6c-2.4-1.9-5.4-3-8.6-3c-1.7 0-3.5 0.4-5.1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBorderCancel);
export default __webpack_public_path__ + "static/media/cross-border-cancel.632519498b9bb1d0056c2dd139545d5a.svg";
export { ForwardRef as ReactComponent };